/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessResponse_AlignmentDetail_ } from '../models/SuccessResponse_AlignmentDetail_';
import type { SuccessResponse_AlignmentListResponse_ } from '../models/SuccessResponse_AlignmentListResponse_';
import type { SuccessResponse_CorporateGradeOverview_ } from '../models/SuccessResponse_CorporateGradeOverview_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CorporateGradeRecordsService {
    /**
     * Get Corporate Grade Overview
     * @returns SuccessResponse_CorporateGradeOverview_ Successful Response
     * @throws ApiError
     */
    public static getCorporateGradeOverviewApiV1CorporateGradeRecordsGet(): CancelablePromise<SuccessResponse_CorporateGradeOverview_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/corporate-grade-records',
        });
    }
    /**
     * List Corporate Grade Alignments
     * @returns SuccessResponse_AlignmentListResponse_ Successful Response
     * @throws ApiError
     */
    public static listCorporateGradeAlignmentsApiV1CorporateGradeRecordsAlignmentsGet({
        matchStatus,
        offset,
        limit = 100,
    }: {
        matchStatus?: ('matched' | 'unmatched' | 'ambiguous' | null),
        offset?: number,
        limit?: number,
    }): CancelablePromise<SuccessResponse_AlignmentListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/corporate-grade-records/alignments',
            query: {
                'match_status': matchStatus,
                'offset': offset,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Corporate Grade Alignment Detail
     * @returns SuccessResponse_AlignmentDetail_ Successful Response
     * @throws ApiError
     */
    public static getCorporateGradeAlignmentDetailApiV1CorporateGradeRecordsAlignmentsAlignmentRecordIdGet({
        alignmentRecordId,
    }: {
        alignmentRecordId: number,
    }): CancelablePromise<SuccessResponse_AlignmentDetail_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/corporate-grade-records/alignments/{alignment_record_id}',
            path: {
                'alignment_record_id': alignmentRecordId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
